import './sass/app.scss'
import './startup'

import Vue from 'vue'
import VueMeta from 'vue-meta'
import DeviceQueries from 'vue-device-queries'
import moment from 'moment'
// eslint-disable-next-line
import 'moment/locale/fr'

import App from './App.vue'
import router from './router'
import ScrollHub from './plugins/scrollHub'
import ScrollUtils from './plugins/ScrollUtils'
import { GlobalComponents } from './components'
import WpApi from './plugins/wpApi'

const offset = window.innerHeight * 0.2
const scrollingElement = document.scrollingElement || document.documentElement

moment.locale('fr')

Vue.config.productionTip = false

Vue.use(ScrollHub, { scrollingElement, scrollEventTarget: window, reveal: { offset }, trigger: { offset } })
Vue.use(ScrollUtils, { scrollEventTarget: window })
Vue.use(GlobalComponents)
Vue.use(DeviceQueries, { laptop: `min-width: 1200px`, tablet: `min-width: 750px`, phoneH: `min-width: 568px` })
Vue.use(VueMeta)
Vue.use(WpApi)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
